module.exports = __webpack_public_path__ + "static/uga-b98f16facd94d9bfdcd1ae8b958aabde.png";